import dayjs from "dayjs";
import jwt_Decode from "jwt-decode";

const baseURL = process.env.REACT_APP_URL;

export const customInterceptor = async (
  url,
  options = {}
) => {
  try {
    const idToken = sessionStorage.getItem("idToken");
    const expiresIn = sessionStorage.getItem("expiresIn");
    if (!idToken) {
      window.location.replace("/signin");
      return;
    }
    const user = jwt_Decode(idToken);
    const isExpired = dayjs().unix() - user?.auth_time >= Number(expiresIn);
    if (isExpired) {
      sessionStorage.clear();
      window.location.replace("/signin");
      return;
    }
    const response = await fetch(
      `${baseURL}/${url}`,
      {
        ...options,
        headers: {
          Authorization: `Bearer ${idToken}`,
          ...(options.headers || {}),
        },
      }
    );

    if (
      response.status === 401
    ) {
      window.location.replace("/senyoError");
      return;
    }
    const data = await response.json();
    return data;
  } catch (error) {
    console.error(
      "customInterceptor error:",
      error
    );
    throw error;
  }
};

/**
 * Legacy GET wrapper.
 * Keep temporarily if other files still use it.
 */
export const originalrequest =
  async (
    url,
    idToken
  ) => {
    try {
      const response =
        await fetch(
          `${baseURL}/${url}`,
          {
            method: "GET",

            headers: {
              Authorization:
                `Bearer ${idToken}`,
            },
          }
        );

      if (
        response.status === 401
      ) {
        window.location.replace(
          "/senyoError"
        );
        return;
      }

      return response.json();
    } catch (error) {
      throw error;
    }
  };